import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { api_crud_base, api_crud_route, endpoints, data_interface } from './Config';
import { getTokenInfo } from '../../../../UseToken';
import { reqGET, reqPUT, translate } from '../../../../Utils';
import UseSidebar from '../../../../UseSidebar';
import Loader from '../../../Loader/Loader';
import Hosts from '../../../../Hosts';
import Swal from 'sweetalert2';
import { language } from './Language';

import Intranet_Competicoes from '../Competicoes/Init'

const MODALIDADES_LISTA = [
	{ value: 'ski_de_fundo', label: 'Esqui de Fundo' },
	{ value: 'curling', label: 'Curling' },
	{ value: 'ski_alpino', label: 'Esqui Alpino' },
	{ value: 'bobsled', label: 'Bobsled' },
	{ value: 'hoquei_no_gelo', label: 'Hóquei no Gelo' },
	{ value: 'luge', label: 'Luge' },
	{ value: 'snowboard', label: 'Snowboard' },
	{ value: 'skeleton', label: 'Skeleton' },
	{ value: 'patinagem_artistica', label: 'Patinagem Artística' },
	{ value: 'patinagem_de_velocidade', label: 'Patinagem de Velocidade' },
	{ value: 'ski_freestyle', label: 'Esqui Freestyle' },
	{ value: 'biatlo', label: 'Biatlo' },
];

const TIPO_JOGO_LISTA = [
	{ value: 'conference', label: 'Conference' },
	{ value: 'non_conference', label: 'Non-Conference' },
	{ value: 'playoff', label: 'Playoff Game' },
];

const N_LINHAS_JOGADORES = 20;
const N_LINHAS_SCORING = 18;
const N_LINHAS_PENALIDADES = 13;
const N_LINHAS_DEFESAS = 4;
const N_ARBITROS = 3;

const get_label = (lista, value) => lista.find(o => o.value === value)?.label ?? value ?? '-';

const ajustar_tamanho = (arr, size, factory) => {
	const base = Array.isArray(arr) ? arr.slice(0, size).map(el => ({ ...factory(), ...el })) : []
	while (base.length < size) base.push(factory())
	return base
}

const nova_linha_scoring = () => ({ equipa: '', periodo: '', marcador: '', assist1: '', assist2: '', horario: '' })
const nova_linha_penalidade = () => ({ periodo: '', numero: '', tempo: '', infracao: '' })

const soma_periodos = (obj) => {
	const p1 = parseInt(obj?.p1, 10) || 0
	const p2 = parseInt(obj?.p2, 10) || 0
	const p3 = parseInt(obj?.p3, 10) || 0
	const ot = parseInt(obj?.ot, 10) || 0
	return p1 + p2 + p3 + ot
}

export default function View(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const permissions = useRef(null);

	const [lang, set_lang] = useState('pt');
	const [isloading, setLoading] = useState(true);
	const [naoencontrado, setNaoEncontrado] = useState(false);

	const [temporadas_lista, set_temporadas_lista] = useState([]);
	const [clubes_lista, set_clubes_lista] = useState([]);
	const [atletas_lista, set_atletas_lista] = useState([]);
	const [convocatorias, set_convocatorias] = useState([]);

	const item_id = props?.location?.state?.item?.id;

	const ensure_defaults = (d) => {
		const info_defaults = JSON.parse(JSON.stringify(data_interface.info))

		d.info = { ...info_defaults, ...d.info }
		Object.keys(info_defaults).forEach(k => {
			if (d.info[k] === null || d.info[k] === undefined) {
				d.info[k] = info_defaults[k]
			}
		})

		d.info.golos_periodo = {
			casa: { p1: '', p2: '', p3: '', ot: '', ...(d.info.golos_periodo?.casa || {}) },
			visitante: { p1: '', p2: '', p3: '', ot: '', ...(d.info.golos_periodo?.visitante || {}) },
		}
		d.info.paragem_tempo = {
			casa: { periodo: '', horario: '', ...(d.info.paragem_tempo?.casa || {}) },
			visitante: { periodo: '', horario: '', ...(d.info.paragem_tempo?.visitante || {}) },
		}
		d.info.mesa_jogo = { nome: '', ...(d.info.mesa_jogo || {}) }

		// Scoring e Penalidades: número de linhas variável (o utilizador pode adicionar/remover).
		// Só aplicamos o número de linhas por omissão quando o registo ainda não tem nenhuma linha guardada.
		d.info.scoring = (Array.isArray(d.info.scoring) && d.info.scoring.length > 0)
			? d.info.scoring.map(el => ({ ...nova_linha_scoring(), ...el }))
			: Array.from({ length: N_LINHAS_SCORING }, nova_linha_scoring)

		d.info.penalidades_casa = (Array.isArray(d.info.penalidades_casa) && d.info.penalidades_casa.length > 0)
			? d.info.penalidades_casa.map(el => ({ ...nova_linha_penalidade(), ...el }))
			: Array.from({ length: N_LINHAS_PENALIDADES }, nova_linha_penalidade)

		d.info.penalidades_visitante = (Array.isArray(d.info.penalidades_visitante) && d.info.penalidades_visitante.length > 0)
			? d.info.penalidades_visitante.map(el => ({ ...nova_linha_penalidade(), ...el }))
			: Array.from({ length: N_LINHAS_PENALIDADES }, nova_linha_penalidade)

		d.info.defesas = ajustar_tamanho(d.info.defesas, N_LINHAS_DEFESAS, () => ({ nome: '', p1: '', p2: '', p3: '', ot: '', golos_sofridos: '', min_jogados: '' }))
		d.info.arbitros = ajustar_tamanho(d.info.arbitros, N_ARBITROS, () => ({ nome: '', numero: '' }))

		return d
	}

	const fetch_id_info = async (id) => {
		try {
			const res = await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`);
			const jogo = res.data[0];

			if (!jogo) {
				setNaoEncontrado(true)
				return
			}

			set_dados(dados.current = ensure_defaults(jogo))
		} catch (error) {
			console.log(error);
			setNaoEncontrado(true)
		}
	};

	const fetch_clubes = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Clube`)
			if (res.data !== undefined) set_clubes_lista(res.data)
		} catch (error) {
			console.error('Erro ao carregar lista de clubes:', error)
		}
	}

	const fetch_atletas = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${getTokenInfo().companycode}/*`)
			if (res.data !== undefined) set_atletas_lista(res.data)
		} catch (error) {
			console.error('Erro ao carregar lista de atletas:', error)
		}
	}

	const fetch_convocatorias = async () => {
		try {
			const res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/convocatorias`)
			if (res.data !== undefined) set_convocatorias(res.data)
		} catch (error) {
			console.error('Erro ao carregar lista de convocatórias:', error)
		}
	}

	const order_array_desc = (array) => {
		return array.sort((a, b) => b.name.localeCompare(a.name, undefined, { numeric: true, sensitivity: 'base' }));
	}

	const fetch_temporadas = async () => {
		let res = await reqGET(`${api_crud_base}/intranet/components/type/${getTokenInfo().companycode}/temporada`)
		let result = []

		if (res.data !== undefined) {
			for await (let el of res.data) {
				if (!el.info.avaiable) continue
				result.push({ id: el.id, name: translate(el.info.title, 'pt') })
			}
		}

		if (result.length > 0) {
			result = order_array_desc(result)
			set_temporadas_lista(result.map(el => ({ id: el.id, label: el.name })))
		}
	}

	let get_permissions = async (e, sidebar) => {
		let handleSingleCheck = async (e, sidebar) => {
			const name = e;

			let ver_submenu = async (node) => {
				if (node.submenu.length !== 0) {
					for await (let subitem of node.submenu) {
						if (subitem.path === name) {
							let aux = {}
							if (permissions.current !== null) {
								aux = permissions.current
								if (aux.create !== true) aux.create = subitem.create
								if (aux.edit !== true) aux.edit = subitem.edit
								if (aux.remove !== true) aux.remove = subitem.remove
							} else {
								aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
							}
							permissions.current = aux
						} else {
							await ver_submenu(subitem)
						}
					}
				}
			}

			for await (let node of sidebar) {
				if (node.path === name) {
					let aux = {}
					if (permissions.current !== null) {
						aux = permissions.current
						if (aux.create !== true) aux.create = node.create
						if (aux.edit !== true) aux.edit = node.edit
						if (aux.remove !== true) aux.remove = node.remove
					} else {
						aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
					}
					permissions.current = aux
					if (Array.isArray(node.submenu) && node.submenu.length > 0) await ver_submenu(node)
				} else {
					await ver_submenu(node)
				}
			}
		}

		await handleSingleCheck(e, sidebar)
	}

	useEffect(() => {
		set_lang(localStorage.getItem('lang'))

		const fetch_permissions = async () => {
			await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(endpoints.list, v) })
			if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {
				for await (let el of getTokenInfo().entity_profile) {
					await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(endpoints.list, v) })
				}
			}
		}

		if (!item_id) {
			setNaoEncontrado(true)
			setLoading(false)
			return
		}

		Promise.all([
			fetch_id_info(item_id),
			fetch_clubes(),
			fetch_atletas(),
			fetch_convocatorias(),
			fetch_temporadas(),
			fetch_permissions(),
		]).then(() => setLoading(false))

	}, [item_id])

	if (isloading) return <Loader />;

	if (naoencontrado || !dados.current) {
		return (
			<main>
				<div className="dash-cards header">
					<h2 className="dash-title">{language[lang]?.jogo ?? 'Jogo'}</h2>
				</div>
				<div className="dash-cards body">
					<div className="container">
						<p className="text-muted">{language[lang]?.not_found ?? 'Registo não encontrado.'}</p>
					</div>
				</div>
			</main>
		);
	}

	const info = dados.current.info;
	const jogo_id = dados.current.id;
	const pode_editar = permissions.current !== null && permissions.current.edit;

	const modalidade_label = get_label(MODALIDADES_LISTA, info.modalidade)
	const tipo_jogo_label = get_label(TIPO_JOGO_LISTA, info.tipo_jogo)
	const nome_casa = info.equipa_casa?.label || ''
	const nome_visitante = info.equipa_visitante?.label || ''

	const normalizar_epoca = (valor) => {
		if (!valor) return ''
		const partes = String(valor).split('/').map(p => p.trim())
		if (partes.length !== 2) return String(valor).trim()
		const [inicio, fim] = partes
		if (fim.length === 4) return `${inicio}/${fim}`
		if (fim.length === 2 && inicio.length === 4) return `${inicio}/${inicio.slice(0, 2)}${fim}`
		return `${inicio}/${fim}`
	}

	const normalizar_lista_por_epoca = (valor, epoca) => {
		if (Array.isArray(valor)) return valor
		if (valor && typeof valor === 'object') return valor[epoca] || []
		return []
	}

	const convocatorias_da_temporada = convocatorias.filter(c => normalizar_epoca(c?.info?.epoca) === normalizar_epoca(info.temporada))

	const get_equipas_disponiveis = () => {

		const mapa = new Map()	
		let clubes = []
		if(Array.isArray(props?.location?.state?.equipas)) {
			clubes = props.location.state.equipas
		}
		else {
			let aux_equipas = []
			// let res_e = await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Clube`)
			// console.log('res_e', res_e)
			if(Array.isArray(clubes_lista) && clubes_lista.length > 0) {
				clubes_lista.forEach(e => {
					aux_equipas.push({
						value: e.id,
						label: e.name
					})
				})
			}
			clubes = aux_equipas
		}
		clubes.forEach(cl => {
			if (!mapa.has(String(cl.id !== undefined ? cl.id : cl.value)))
				 mapa.set(String(cl.id !== undefined ? cl.id : cl.value), { value: (cl.id !== undefined ? cl.id : cl.value), label: (cl.label !== undefined ? cl.label : cl.name) })
		})

		console.log('clubes', clubes)
		console.log('mapa', mapa)

		/*
		const mapa = new Map()
		convocatorias_da_temporada.forEach(c => {
			const clubes = normalizar_lista_por_epoca(c?.info?.clubes_inscritos, c?.info?.epoca)

			clubes.forEach(cl => {
				if (!mapa.has(String(cl.id))) mapa.set(String(cl.id), { value: cl.id, label: (cl.label !== undefined ? cl.label : cl.name) })
			})
		})
		*/
		return Array.from(mapa.values()).sort((a, b) => a.label.localeCompare(b.label))
	}

	const clube_ids = new Set(clubes_lista.map(c => String(c.id)))

	const get_modalidades_entidade = (entidade) => {
		const mods = entidade?.info?.modalidades ?? entidade?.modalidades
		return Array.isArray(mods) ? mods.map(m => (m?.value ?? m)) : []
	}

	const get_jogadores_disponiveis = (clube_id) => {
		if (!clube_id || !info.modalidade) return []
		return atletas_lista
			.filter(e => !clube_ids.has(String(e.id)))
			.filter(e => {
				const clube_entidade = e?.info?.clube ?? e?.clube
				const clube_entidade_id = clube_entidade?.id ?? clube_entidade
				return String(clube_entidade_id) === String(clube_id)
			})
			.filter(e => get_modalidades_entidade(e).includes(info.modalidade))
			.map(e => ({
				id: e.id,
				label: e?.info?.name ?? e?.name ?? '',
				numero_atleta: e?.info?.numero_atleta ?? e?.numero_atleta ?? '',
			}))
			.sort((a, b) => (Number(a.numero_atleta) || 0) - (Number(b.numero_atleta) || 0))
	}

	const get_treinadores_disponiveis = () => {
		const mapa = new Map()
		convocatorias_da_temporada.forEach(c => {
			const treinadores = normalizar_lista_por_epoca(c?.info?.treinadores_inscritos, c?.info?.epoca)
			treinadores.forEach(t => {
				if (!mapa.has(String(t.id))) mapa.set(String(t.id), t)
			})
		})
		return Array.from(mapa.values()).sort((a, b) => (a.label || '').localeCompare(b.label || ''))
	}

	const equipas_disponiveis = get_equipas_disponiveis()
	const treinadores_disponiveis = get_treinadores_disponiveis()


	console.log('equipas_disponiveis', equipas_disponiveis)

	const handle_change_info = (campo, valor) => {
		set_dados(dados.current.info[campo] = valor)
	}

	const change_temporada = (valor) => {
		set_dados(dados.current.info.temporada = valor)
		set_dados(dados.current.info.equipa_casa = null)
		set_dados(dados.current.info.equipa_visitante = null)
		set_dados(dados.current.info.jogadores_casa = [])
		set_dados(dados.current.info.jogadores_visitante = [])
	}

	const change_modalidade = (valor) => {
		set_dados(dados.current.info.modalidade = valor)
		set_dados(dados.current.info.jogadores_casa = [])
		set_dados(dados.current.info.jogadores_visitante = [])
	}

	const change_equipa = (lado, selected) => {
		const campo_equipa = lado === 'casa' ? 'equipa_casa' : 'equipa_visitante'
		const campo_jogadores = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		set_dados(dados.current.info[campo_equipa] = selected ? { id: selected.value, label: selected.label } : null)
		set_dados(dados.current.info[campo_jogadores] = [])
	}

	const change_treinador = (lado, selected) => {
		const campo = lado === 'casa' ? 'treinador_casa' : 'treinador_visitante'
		set_dados(dados.current.info[campo] = selected ? { id: selected.value, label: selected.label } : null)
	}

	const adicionar_jogador = (lado, jogador) => {
		if (!jogador) return
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		if (atual.some(j => String(j.id) === String(jogador.id))) return
		set_dados(dados.current.info[campo] = [...atual, { id: jogador.id, numero: jogador.numero_atleta ?? '', nome: jogador.label ?? '' }])
	}

	const remover_jogador = (lado, id) => {
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = atual.filter(j => String(j.id) !== String(id)))
	}

	const editar_numero_jogador = (lado, id, numero) => {
		const campo = lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = atual.map(j => String(j.id) === String(id) ? { ...j, numero } : j))
	}

	const update_array_field = (campo, index, sub, value) => {
		const atual = dados.current.info[campo] || []
		const novo = atual.map((item, i) => i === index ? { ...item, [sub]: value } : item)
		set_dados(dados.current.info[campo] = novo)
	}

	const update_nested_field = (campo, lado, sub, value) => {
		const atual = dados.current.info[campo] || {}
		const novo = { ...atual, [lado]: { ...(atual[lado] || {}), [sub]: value } }
		set_dados(dados.current.info[campo] = novo)
	}

	const update_object_field = (campo, sub, value) => {
		const atual = dados.current.info[campo] || {}
		set_dados(dados.current.info[campo] = { ...atual, [sub]: value })
	}

	const adicionar_linha = (campo, factory) => {
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = [...atual, factory()])
	}

	const remover_linha = (campo, index) => {
		const atual = dados.current.info[campo] || []
		set_dados(dados.current.info[campo] = atual.filter((_, i) => i !== index))
	}

	const handleSubmit = () => {
		Swal.fire({
			title: language[lang]?.edit_title ?? 'Editar Registo',
			text: language[lang]?.edit_text ?? 'Tem a certeza que pretende continuar?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang]?.edit_confirm ?? 'Sim',
			cancelButtonText: language[lang]?.edit_cancel ?? 'Não',
		}).then((result) => {
			if (result.isConfirmed) {
				reqPUT(`${api_crud_route}`, dados.current)
					.then(() => {
						Swal.fire(language[lang]?.edit_success ?? 'Registo actualizado com sucesso!', '', 'success')
					})
					.catch(() => Swal.fire(language[lang]?.edit_error ?? 'Problema ao actualizar registo!', '', 'error'))
			}
		})
	}

	const jogadores_da_lista = (lado) => {
		const equipa_selecionada = info[lado === 'casa' ? 'equipa_casa' : 'equipa_visitante']
		const roster = info[lado === 'casa' ? 'jogadores_casa' : 'jogadores_visitante'] || []
		const disponiveis = get_jogadores_disponiveis(equipa_selecionada?.id).filter(
			j => !roster.some(r => String(r.id) === String(j.id))
		)
		return { equipa_selecionada, roster, disponiveis }
	}

	const render_linhas_jogadores = (lado) => {
		const { roster } = jogadores_da_lista(lado)
		const linhas = []
		for (let i = 0; i < N_LINHAS_JOGADORES; i++) {
			const j = roster[i]
			linhas.push(
				<tr key={i} className={!j ? 'linha-vazia' : undefined}>
					<td>
						{j ? (
							pode_editar ? (
								<input
									type="text"
									className="ficha-input text-end"
									value={j.numero}
									onChange={(e) => editar_numero_jogador(lado, j.id, e.target.value)}
								/>
							) : j.numero
						) : ' '}
					</td>
					<td>{j ? j.nome : ' '}</td>
					<td className="text-center no-print">
						{j && pode_editar ? (
							<button type="button" className="ficha-btn-remove rounded-0" onClick={() => remover_jogador(lado, j.id)}>
								<i className="bi bi-x-lg"></i>
							</button>
						) : null}
					</td>
				</tr>
			)
		}
		return linhas
	}

	const render_equipa_select = (lado) => {
		const { equipa_selecionada, disponiveis } = jogadores_da_lista(lado)
		const outra_equipa = info[lado === 'casa' ? 'equipa_visitante' : 'equipa_casa']
		const campo_treinador = lado === 'casa' ? 'treinador_casa' : 'treinador_visitante'

		return (
			<div className="ficha-equipa-box">
				<div className="linha">
					<span className="linha-label">{language[lang]?.[lado === 'casa' ? 'eq_casa' : 'eq_visitante'] ?? (lado === 'casa' ? 'EQ. DA CASA' : 'EQ. VISITANTE')}:</span>{' '}
					{pode_editar ? (
						<div> 
							{equipa_selecionada?.label ? equipa_selecionada.label : ''}
							<select
								className="ficha-input d-none"
								value={equipa_selecionada?.id ?? ''}
								onChange={(e) => {
									const sel = equipas_disponiveis.find(eq => String(eq.value) === e.target.value)
									change_equipa(lado, sel || null)
								}}
							>
								<option value="">{info.temporada ? (language[lang]?.select ?? 'Selecione') : (language[lang]?.selecione_primeiro_epoca ?? 'Selecione primeiro a época')}</option>
								{equipas_disponiveis.filter(eq => String(eq.value) !== String(outra_equipa?.id)).map(eq => (
									<option key={eq.value} value={eq.value}>{eq.label}</option>
								))}
							</select>
						</div>
					) : (
						<span className="linha-valor">{equipa_selecionada?.label || ''}</span>
					)}
				</div>
				<div className="linha d-none">
					<span className="linha-label">{language[lang]?.treinador ?? 'TREINADOR'}:</span>{' '}
					{pode_editar ? (
						<select
							className="ficha-input"
							value={info[campo_treinador]?.id ?? ''}
							onChange={(e) => {
								const sel = treinadores_disponiveis.find(t => String(t.id) === e.target.value)
								change_treinador(lado, sel ? { value: sel.id, label: sel.label } : null)
							}}
						>
							<option value="">{info.temporada ? (language[lang]?.selecionar_treinador ?? 'Selecione o treinador') : (language[lang]?.selecione_primeiro_epoca ?? 'Selecione primeiro a época')}</option>
							{treinadores_disponiveis.map(t => (
								<option key={t.id} value={t.id}>{t.label}</option>
							))}
						</select>
					) : (
						<span className="linha-valor">{info[campo_treinador]?.label || ''}</span>
					)}
				</div>
			</div>
		)
	}

	const render_add_jogador = (lado) => {
		if (!pode_editar) return null
		const { equipa_selecionada, disponiveis } = jogadores_da_lista(lado)

		return (
			<div className="no-print" style={{ margin: '3px 0' }}>
				<select
					className="ficha-input"
					value=""
					disabled={!equipa_selecionada || !info.modalidade}
					onChange={(e) => {
						const jogador = disponiveis.find(j => String(j.id) === e.target.value)
						adicionar_jogador(lado, jogador)
						e.target.value = ''
					}}
				>
					<option value="">
						{!info.modalidade
							? (language[lang]?.selecione_primeiro_modalidade ?? 'Selecione primeiro a modalidade')
							: equipa_selecionada
								? (language[lang]?.escolher_jogador ?? 'Escolher jogador...')
								: (language[lang]?.selecione_primeiro_equipa ?? 'Selecione primeiro a equipa')}
					</option>
					{disponiveis.map(j => (
						<option key={j.id} value={j.id}>{j.numero_atleta ? `${j.numero_atleta} — ${j.label}` : j.label}</option>
					))}
				</select>
			</div>
		)
	}

	const render_botao_adicionar_linha = (campo, factory) => {
		if (!pode_editar) return null
		return (
			<button
				type="button"
				className="ficha-btn-add no-print ms-1"
				onClick={() => adicionar_linha(campo, factory)}
			>
				+ {language[lang]?.adicionar_linha ?? 'Adicionar linha'}
			</button>
		)
	}

	const golos_casa = info.golos_periodo.casa
	const golos_visitante = info.golos_periodo.visitante

	return (
		
		<main style={{
			width: '100vw',
    		left: '0',
    		zIndex: '999'
		}}>
			<style>{`
				@media print {
					@page { size: landscape; margin: 6mm; }
					.no-print { display: none !important; }
					body * { visibility: hidden; }
					.ficha-print, .ficha-print * { visibility: visible; }
					html, body { margin: 0 !important; padding: 0 !important; height: auto !important; }
					.dash-cards.body, .container, .container-fluid, .card {
						margin: 0 !important;
						padding: 0 !important;
						max-width: none !important;
						width: auto !important;
						border: none !important;
						box-shadow: none !important;
					}
					.ficha-print {
						position: fixed !important;
						top: 0 !important;
						left: 0 !important;
						right: 0 !important;
						width: auto !important;
						box-shadow: none !important;
						border: none !important;
						margin: 0 !important;
						padding: 0 !important;
					}
					body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
					.ficha-print select.ficha-input { -webkit-appearance: none; appearance: none; }
					.ficha-print tr.linha-vazia { display: none !important; }
				}

				.ficha-print {
					font-family: Arial, Helvetica, sans-serif;
					color: #000;
					background: #fff;
				}

				.ficha-input {
					border: none;
					border-bottom: 1px solid #000;
					background: transparent;
					font: inherit;
					padding: 0 2px;
					box-sizing: border-box;
					width: 100%;
				}
				.ficha-input:focus { outline: none; }
				table.ficha-tabela .ficha-input { border-bottom: none; font-size: 10px; padding: 0; }
				.ficha-btn-remove {
					border: none; background: #d9214e; color: #fff; width: 16px; height: 16px;
					line-height: 14px; padding: 0; font-size: 11px; border-radius: 2px; cursor: pointer;
				}
				.ficha-btn-add {
					border: 1px dashed #0095e8; background: #fff; color: #0095e8; font-size: 11px;
					padding: 2px 8px; border-radius: 3px; cursor: pointer; margin: 4px 0 8px;
				}
				.ficha-btn-add:hover { background: #0095e8; color: #fff; }

				.ficha-toolbar { display: flex; flex-wrap: wrap; gap: 16px; margin-bottom: 8px; }
				.ficha-toolbar label { font-size: 11px; font-weight: 700; display: block; margin-bottom: 2px; }
				.ficha-toolbar select { min-width: 160px; }

				.ficha-titulo {
					text-align: center;
					font-weight: 800;
					font-size: 20px;
					letter-spacing: .3px;
					margin-bottom: 10px;
				}
				.ficha-campos-topo {
					display: flex;
					flex-wrap: wrap;
					gap: 20px;
					align-items: baseline;
					font-size: 12px;
					margin-bottom: 8px;
				}
				.ficha-campos-topo .campo { display: flex; align-items: baseline; gap: 4px; white-space: nowrap; }
				.ficha-campos-topo .valor { border-bottom: 1px solid #000; min-width: 110px; display: inline-block; padding: 0 2px; }

				.ficha-grid-topo { display: grid; grid-template-columns: 1fr 1.5fr 1fr; gap: 8px; align-items: start; }

				.ficha-equipa-box { border: 1px solid #000; margin-bottom: 0; }
				.ficha-equipa-box .linha { padding: 10px; font-size: 11px; display: flex; align-items: center; gap: 4px; }
				.ficha-equipa-box .linha + .linha { border-top: 1px solid #000; }
				.ficha-equipa-box .linha-label { font-weight: 700; white-space: nowrap; }
				.ficha-equipa-box .linha-valor { font-weight: 400; }
				.ficha-equipa-box select.ficha-input { font-size: 11px; }

				table.ficha-tabela { width: 100%; border-collapse: collapse; table-layout: fixed; }
				table.ficha-tabela th, table.ficha-tabela td {
					border: 1px solid #000;
					font-size: 10px;
					padding: 0 3px;
					height: 15px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				table.ficha-tabela th { background-color: #d0d0d0; text-align: left; font-size: 9.5px; }

				.scoring-wrapper { display: flex; align-items: flex-start; border: 1px solid #000; border-top: none; }
				.scoring-wrapper .scoring-tabela-col { flex: 1 1 auto; min-width: 0; }
				.scoring-key-box {
					flex: 0 0 70px;
					border-left: 1px solid #000;
					background: #fff;
					padding: 2px 3px 3px;
					box-sizing: border-box;
				}
				.scoring-key-box .skb-titulo { font-weight: 800; font-size: 9.5px; margin-bottom: 1.5px; }
				.scoring-key-box .skb-linha { display: block; font-size: 7.5px; line-height: 1.2; margin-bottom: 2px; }
				.scoring-key-box .skb-linha b { font-size: 7.5px; display: block; }

				.ficha-secao-titulo { text-align: center; font-weight: 700; font-size: 11px; margin: 6px 0 2px; }

				.ficha-grid-baixo { display: grid; grid-template-columns: 0.85fr 1.25fr 0.85fr; gap: 8px; margin-top: 4px; }

				.ficha-paragem { font-size: 11px; margin-top: 8px; }
				.ficha-paragem .titulo-inline { font-weight: 700; }
				.ficha-paragem-linha { display: flex; align-items: baseline; gap: 20px; margin: 3px 0; }
				.ficha-paragem-linha .rotulo { width: 90px; }
				.ficha-paragem-linha .blank { border-bottom: 1px solid #000; min-width: 60px; display: inline-block; }
				.ficha-paragem-linha .blank input { width: 100%; }

				.ficha-arbitro-linha { display: flex; align-items: baseline; gap: 8px; font-size: 11px; margin: 3px 0; }
				.ficha-arbitro-linha .blank-nome { border-bottom: 1px solid #000; flex: 1; min-width: 160px; display: inline-block; }
				.ficha-arbitro-linha .blank-num { border-bottom: 1px solid #000; min-width: 90px; display: inline-block; }
			`}</style>

			<div className="dash-cards body">
				<div className="container-fluid">
					<div className="card mb-4">
						<div className="card-body ficha-print">

							<div className="ficha-titulo">
								{(language[lang]?.ficha_jogo ?? 'Ficha de Jogo').toUpperCase()} DE {modalidade_label !== '-' ? modalidade_label.toUpperCase() : '___'}
								{info.temporada ? ` — ${(language[lang]?.temporada_label ?? 'Temporada').toUpperCase()} ${info.temporada}` : ''}
							</div>

							<div className="ficha-campos-topo">
								<span className="campo">{(language[lang]?.pista ?? 'Pista').toUpperCase()} {pode_editar ? (
									<input type="text" className="ficha-input valor" style={{ minWidth: 110 }} value={info.pista} onChange={(e) => handle_change_info('pista', e.target.value)} />
								) : (
									<span className="valor">{info.pista || ' '}</span>
								)}</span>
								<span className="campo">{language[lang]?.hora_inicio ?? 'Hora Início'} {pode_editar ? (
									<input type="time" className="ficha-input valor" style={{ minWidth: 60 }} value={info.hora_inicio} onChange={(e) => handle_change_info('hora_inicio', e.target.value)} />
								) : (
									<span className="valor" style={{ minWidth: 60 }}>{info.hora_inicio || ' '}</span>
								)}</span>
								<span className="campo">{language[lang]?.data_jogo ?? 'Data'} {pode_editar ? (
									<input type="date" className="ficha-input valor" style={{ minWidth: 110 }} value={info.data_jogo} onChange={(e) => handle_change_info('data_jogo', e.target.value)} />
								) : (
									<span className="valor">{info.data_jogo || ' '}</span>
								)}</span>
								<span className="campo">{language[lang]?.tipo_jogo_pdf ?? 'Conference, Non-Conference, or Playoff Game'} {pode_editar ? (
									<select className="ficha-input valor" style={{ minWidth: 110 }} value={info.tipo_jogo} onChange={(e) => handle_change_info('tipo_jogo', e.target.value)}>
										<option value="">{language[lang]?.select ?? 'Selecione'}</option>
										{TIPO_JOGO_LISTA.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
									</select>
								) : (
									<span className="valor">{tipo_jogo_label !== '-' ? tipo_jogo_label : ' '}</span>
								)}</span>
							</div>

							<div className="ficha-grid-topo">

								<div>
									{render_equipa_select('casa')}
									{/*render_add_jogador('casa')*/}
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th className="text-end" style={{ maxWidth: '80px' }}>{language[lang]?.numero ?? 'N.º'}</th>
												<th className='w-75'>{language[lang]?.nome_jogadores ?? 'NOME DOS JOGADORES'}</th>
												<th className="text-center no-print" style={{ maxWidth: '80px' }}></th>
											</tr>
										</thead>
										<tbody>
											{render_linhas_jogadores('casa')}
										</tbody>
									</table>
								</div>

								<div>
									<div className="scoring-wrapper">
										<div className="scoring-tabela-col">
											<table className="ficha-tabela" style={{ borderTop: '1px solid #000' }}>
												<thead>
													<tr>
														<th className='text-center' style={{ width: '20%' }}>{language[lang]?.equipa_marcou ?? 'Equipa que Marcou'}</th>
														<th className='text-center' style={{ width: '8%', writingMode: 'vertical-rl' }}>{language[lang]?.periodo ?? 'Período'}</th>
														<th className='text-center' style={{ width: '8%', writingMode: 'vertical-rl' }}>{language[lang]?.marcador ?? 'Marcador'}</th>
														<th className='text-center' style={{ width: '8%', writingMode: 'vertical-rl' }}>{language[lang]?.primeiro_assist ?? '1º Assist.'}</th>
														<th className='text-center' style={{ width: '8%', writingMode: 'vertical-rl' }}>{language[lang]?.segundo_assist ?? '2º Assist.'}</th>
														<th className='text-center text-wrap' style={{ width: '8%', writingMode: 'vertical-rl' }}>{language[lang]?.horario_golo ?? 'Horário do Golo'}</th>
														<th className='' style={{ width: '30%' }}>
															<div className="skb-titulo fw-bolder">{language[lang]?.scoring_key_titulo ?? 'Scoring Key'}</div>
															<div className="skb-linha"><b>{language[lang]?.scoring_ev ?? 'EV -'}</b><span className="text-wrap"> {language[lang]?.scoring_ev_desc ?? 'No tempo normal'}</span></div>
															<div className="skb-linha"><b>{language[lang]?.scoring_pp ?? 'PP -'}</b><span className="text-wrap"> {language[lang]?.scoring_pp_desc ?? 'Durante o tempo de penalidade da outra equipa'}</span></div>
															<div className="skb-linha"><b>{language[lang]?.scoring_sh ?? 'SH -'}</b><span className="text-wrap"> {language[lang]?.scoring_sh_desc ?? 'Durante o tempo de penalidade da própria equipa'}</span></div>
														</th>
														<th className="no-print" style={{ maxWidth: '20px' }}></th>
													</tr>
												</thead>
												<tbody>
													{info.scoring.map((linha, k) => (
														<tr key={k}>
															<td>
																{pode_editar ? (
																	<select className="ficha-input" value={linha.equipa} onChange={(e) => update_array_field('scoring', k, 'equipa', e.target.value)}>
																		<option value=""></option>
																		{nome_casa && <option value={nome_casa}>{nome_casa}</option>}
																		{nome_visitante && <option value={nome_visitante}>{nome_visitante}</option>}
																	</select>
																) : (linha.equipa || ' ')}
															</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.periodo} onChange={(e) => update_array_field('scoring', k, 'periodo', e.target.value)} /> : (linha.periodo || ' ')}</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.marcador} onChange={(e) => update_array_field('scoring', k, 'marcador', e.target.value)} /> : (linha.marcador || ' ')}</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.assist1} onChange={(e) => update_array_field('scoring', k, 'assist1', e.target.value)} /> : (linha.assist1 || ' ')}</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.assist2} onChange={(e) => update_array_field('scoring', k, 'assist2', e.target.value)} /> : (linha.assist2 || ' ')}</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.horario} onChange={(e) => update_array_field('scoring', k, 'horario', e.target.value)} /> : (linha.horario || ' ')}</td>
															<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.key} onChange={(e) => update_array_field('scoring', k, 'key', e.target.value)} /> : (linha.key || ' ')}</td>
															<td className="no-print text-center" style={{ maxWidth: '20px' }}>
																{pode_editar ? <button type="button" className="ficha-btn-remove rounded-0" onClick={() => remover_linha('scoring', k)}>
																	<i className="bi bi-x-lg"></i>
																</button> : null}
															</td>
														</tr>
													))}
												</tbody>
											</table>
											{render_botao_adicionar_linha('scoring', nova_linha_scoring)}
										</div>
										<div className="scoring-key-box d-none">
											<div className="skb-titulo">{language[lang]?.scoring_key_titulo ?? 'Scoring Key'}</div>
											<div className="skb-linha"><b>{language[lang]?.scoring_ev ?? 'EV -'}</b><span>{language[lang]?.scoring_ev_desc ?? 'No tempo normal'}</span></div>
											<div className="skb-linha"><b>{language[lang]?.scoring_pp ?? 'PP -'}</b><span>{language[lang]?.scoring_pp_desc ?? 'Durante o tempo de penalidade da outra equipa'}</span></div>
											<div className="skb-linha"><b>{language[lang]?.scoring_sh ?? 'SH -'}</b><span>{language[lang]?.scoring_sh_desc ?? 'Durante o tempo de penalidade da própria equipa'}</span></div>
										</div>
									</div>

									<div className="ficha-secao-titulo">{language[lang]?.golos_por_periodo ?? 'GOLOS POR PERÍODO'}</div>
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th style={{ width: '32%' }}>{language[lang]?.nome_equipa ?? 'Nome da Equipa'}</th>
												<th className='text-center'>{language[lang]?.periodo_1 ?? '1st'}</th>
												<th className='text-center'>{language[lang]?.periodo_2 ?? '2nd'}</th>
												<th className='text-center'>{language[lang]?.periodo_3 ?? '3rd'}</th>
												<th className='text-center'>{language[lang]?.periodo_ot ?? 'OT'}</th>
												<th className='text-center fw-bolder'>{language[lang]?.total ?? 'Total'}</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>{nome_casa || ' '}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_casa.p1} onChange={(e) => update_nested_field('golos_periodo', 'casa', 'p1', e.target.value)} /> : (golos_casa.p1 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_casa.p2} onChange={(e) => update_nested_field('golos_periodo', 'casa', 'p2', e.target.value)} /> : (golos_casa.p2 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_casa.p3} onChange={(e) => update_nested_field('golos_periodo', 'casa', 'p3', e.target.value)} /> : (golos_casa.p3 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_casa.ot} onChange={(e) => update_nested_field('golos_periodo', 'casa', 'ot', e.target.value)} /> : (golos_casa.ot || ' ')}</td>
												<td className="text-center fw-bolder">{soma_periodos(golos_casa) || ' '}</td>
											</tr>
											<tr>
												<td>{nome_visitante || ' '}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_visitante.p1} onChange={(e) => update_nested_field('golos_periodo', 'visitante', 'p1', e.target.value)} /> : (golos_visitante.p1 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_visitante.p2} onChange={(e) => update_nested_field('golos_periodo', 'visitante', 'p2', e.target.value)} /> : (golos_visitante.p2 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_visitante.p3} onChange={(e) => update_nested_field('golos_periodo', 'visitante', 'p3', e.target.value)} /> : (golos_visitante.p3 || ' ')}</td>
												<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={golos_visitante.ot} onChange={(e) => update_nested_field('golos_periodo', 'visitante', 'ot', e.target.value)} /> : (golos_visitante.ot || ' ')}</td>
												<td className="text-center fw-bolder">{soma_periodos(golos_visitante) || ' '}</td>
											</tr>
										</tbody>
									</table>
								</div>

								<div>
									{render_equipa_select('visitante')}
									{/*render_add_jogador('visitante')*/}
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th className='text-end' style={{ maxWidth: '80px' }}>{language[lang]?.numero ?? 'N.º'}</th>
												<th className='w-75'>{language[lang]?.nome_jogadores ?? 'NOME DOS JOGADORES'}</th>
												<th className="text-center no-print" style={{ maxWidth: '80px' }}></th>
											</tr>
										</thead>
										<tbody>
											{render_linhas_jogadores('visitante')}
										</tbody>
									</table>
								</div>

							</div>

							<div className="ficha-grid-baixo">

								<div>
									<div className="ficha-secao-titulo">{language[lang]?.penalidades_casa ?? 'PENALIDADES EQUIPA DA CASA'}</div>
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th className='text-center' style={{ width: '10%' }}>{language[lang]?.per ?? 'Per.'}</th>
												<th className='text-center' style={{ width: '10%' }}>{language[lang]?.numero ?? 'N.º'}</th>
												<th className='text-center' style={{ width: '20%' }}>{language[lang]?.tempo_penalidade ?? 'Tempo'}</th>
												<th className='w-50'>{language[lang]?.infracao ?? 'Infração'}</th>
												<th className="no-print text-center" style={{ maxWidth: '80px' }}></th>
											</tr>
										</thead>
										<tbody>
											{info.penalidades_casa.map((linha, k) => (
												<tr key={k}>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.periodo} onChange={(e) => update_array_field('penalidades_casa', k, 'periodo', e.target.value)} /> : (linha.periodo || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.numero} onChange={(e) => update_array_field('penalidades_casa', k, 'numero', e.target.value)} /> : (linha.numero || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.tempo} onChange={(e) => update_array_field('penalidades_casa', k, 'tempo', e.target.value)} /> : (linha.tempo || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input" value={linha.infracao} onChange={(e) => update_array_field('penalidades_casa', k, 'infracao', e.target.value)} /> : (linha.infracao || ' ')}</td>
													<td className="no-print text-center" style={{ maxWidth: '80px' }}>
														{pode_editar ? <button type="button" className="ficha-btn-remove rounded-0" onClick={() => remover_linha('penalidades_casa', k)}>
															<i className="bi bi-x-lg"></i>
														</button> : null}
													</td>
												</tr>
											))}
										</tbody>
									</table>
									{render_botao_adicionar_linha('penalidades_casa', nova_linha_penalidade)}
								</div>

								<div>
									<div className="ficha-secao-titulo">{language[lang]?.defesas_por_periodo ?? 'DEFESAS POR PERÍODO'}</div>
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th style={{ width: '20%' }}>{language[lang]?.nome_gr ?? 'Nome do G.R.'}</th>
												<th className='text-center' style={{ width: '8%' }}>{language[lang]?.periodo_1 ?? '1st'}</th>
												<th className='text-center' style={{ width: '8%' }}>{language[lang]?.periodo_2 ?? '2nd'}</th>
												<th className='text-center' style={{ width: '8%' }}>{language[lang]?.periodo_3 ?? '3rd'}</th>
												<th className='text-center' style={{ width: '7%' }}>{language[lang]?.periodo_ot ?? 'OT'}</th>
												<th className='text-center' style={{ width: '10%' }}>{language[lang]?.total ?? 'Total'}</th>
												<th className='text-center' style={{ width: '19%' }}>{language[lang]?.total_golos_sofridos ?? 'Total de Golos Sofridos'}</th>
												<th className='text-center'>{language[lang]?.total_min_jogados ?? 'Total de Min. Jogados'}</th>
											</tr>
										</thead>
										<tbody>
											{info.defesas.map((linha, k) => (
												<tr key={k}>
													<td>{pode_editar ? <input type="text" className="ficha-input" value={linha.nome} onChange={(e) => update_array_field('defesas', k, 'nome', e.target.value)} /> : (linha.nome || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.p1} onChange={(e) => update_array_field('defesas', k, 'p1', e.target.value)} /> : (linha.p1 || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.p2} onChange={(e) => update_array_field('defesas', k, 'p2', e.target.value)} /> : (linha.p2 || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.p3} onChange={(e) => update_array_field('defesas', k, 'p3', e.target.value)} /> : (linha.p3 || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.ot} onChange={(e) => update_array_field('defesas', k, 'ot', e.target.value)} /> : (linha.ot || ' ')}</td>
													<td className="text-center">{soma_periodos(linha) || ' '}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.golos_sofridos} onChange={(e) => update_array_field('defesas', k, 'golos_sofridos', e.target.value)} /> : (linha.golos_sofridos || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.min_jogados} onChange={(e) => update_array_field('defesas', k, 'min_jogados', e.target.value)} /> : (linha.min_jogados || ' ')}</td>
												</tr>
											))}
										</tbody>
									</table>

									<div className="ficha-paragem">
										<div className="ficha-paragem-linha justify-content-around px-5 mt-3">
											<span className="titulo-inline" style={{ minWidth: '100px' }}>{language[lang]?.paragem_tempo ?? 'Paragem de tempo:'}</span>
											<span style={{ minWidth: '150px', textAlign: 'center' }}>{language[lang]?.periodo_maiusc ?? 'PERÍODO'}</span>
											<span style={{ minWidth: '150px', textAlign: 'center' }}>{language[lang]?.horario_maiusc ?? 'HORÁRIO'}</span>
										</div>
										<div className="ficha-paragem-linha justify-content-around px-5">
											<span className="rotulo" style={{ minWidth: '100px' }}>{language[lang]?.eq_casa_curto ?? 'Eq. da Casa'}</span>
											<span className="blank">{pode_editar ? <input type="text" className="ficha-input" value={info.paragem_tempo.casa.periodo} onChange={(e) => update_nested_field('paragem_tempo', 'casa', 'periodo', e.target.value)} /> : (info.paragem_tempo.casa.periodo || ' ')}</span>
											<span className="blank">{pode_editar ? <input type="text" className="ficha-input" value={info.paragem_tempo.casa.horario} onChange={(e) => update_nested_field('paragem_tempo', 'casa', 'horario', e.target.value)} /> : (info.paragem_tempo.casa.horario || ' ')}</span>
										</div>
										<div className="ficha-paragem-linha justify-content-around px-5 mb-5">
											<span className="rotulo" style={{ minWidth: '100px' }}>{language[lang]?.eq_visitante_curto ?? 'Eq. Visitante'}</span>
											<span className="blank">{pode_editar ? <input type="text" className="ficha-input" value={info.paragem_tempo.visitante.periodo} onChange={(e) => update_nested_field('paragem_tempo', 'visitante', 'periodo', e.target.value)} /> : (info.paragem_tempo.visitante.periodo || ' ')}</span>
											<span className="blank">{pode_editar ? <input type="text" className="ficha-input" value={info.paragem_tempo.visitante.horario} onChange={(e) => update_nested_field('paragem_tempo', 'visitante', 'horario', e.target.value)} /> : (info.paragem_tempo.visitante.horario || ' ')}</span>
										</div>

										{info.arbitros.map((arb, k) => (
											<div className="ficha-arbitro-linha px-3" key={k}>
												<span style={{ width: '100px' }}>{language[lang]?.arbitro ?? 'Árbitro'}</span>
												<span className="blank-nome">{pode_editar ? <input type="text" className="ficha-input" value={arb.nome} onChange={(e) => update_array_field('arbitros', k, 'nome', e.target.value)} /> : (arb.nome || ' ')}</span>
												<span>#</span>
												<span className="blank-num">{pode_editar ? <input type="text" className="ficha-input" value={arb.numero} onChange={(e) => update_array_field('arbitros', k, 'numero', e.target.value)} /> : (arb.numero || ' ')}</span>
											</div>
										))}
										<div className="ficha-arbitro-linha px-3">
											<span style={{ width: '100px' }}>{language[lang]?.mesa_jogo ?? 'Mesa de jogo'}</span>
											<span className="blank-nome">{pode_editar ? <input type="text" className="ficha-input" value={info.mesa_jogo.nome} onChange={(e) => update_object_field('mesa_jogo', 'nome', e.target.value)} /> : (info.mesa_jogo.nome || ' ')}</span>
										</div>
									</div>
								</div>

								<div>
									<div className="ficha-secao-titulo">{language[lang]?.penalidades_visitante ?? 'PENALIDADES EQUIPA VISITANTE'}</div>
									<table className="ficha-tabela">
										<thead>
											<tr>
												<th className='text-center' style={{ width: '10%' }}>{language[lang]?.per ?? 'Per.'}</th>
												<th className='text-center' style={{ width: '10%' }}>{language[lang]?.numero ?? 'N.º'}</th>
												<th className='text-center' style={{ width: '20%' }}>{language[lang]?.tempo_penalidade ?? 'Tempo'}</th>
												<th className='w-50'>{language[lang]?.infracao ?? 'Infração'}</th>
												<th className="no-print text-center" style={{ maxWidth: '80px' }}></th>
											</tr>
										</thead>
										<tbody>
											{info.penalidades_visitante.map((linha, k) => (
												<tr key={k}>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.periodo} onChange={(e) => update_array_field('penalidades_visitante', k, 'periodo', e.target.value)} /> : (linha.periodo || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.numero} onChange={(e) => update_array_field('penalidades_visitante', k, 'numero', e.target.value)} /> : (linha.numero || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input text-center" value={linha.tempo} onChange={(e) => update_array_field('penalidades_visitante', k, 'tempo', e.target.value)} /> : (linha.tempo || ' ')}</td>
													<td>{pode_editar ? <input type="text" className="ficha-input" value={linha.infracao} onChange={(e) => update_array_field('penalidades_visitante', k, 'infracao', e.target.value)} /> : (linha.infracao || ' ')}</td>
													<td className="no-print" style={{ maxWidth: '80px' }}>
														{pode_editar ? <button type="button" className="ficha-btn-remove rounded-0" onClick={() => remover_linha('penalidades_visitante', k)}>
															<i className="bi bi-x-lg"></i>
														</button> : null}
													</td>
												</tr>
											))}
										</tbody>
									</table>
									{render_botao_adicionar_linha('penalidades_visitante', nova_linha_penalidade)}
								</div>

							</div>

						</div>
					</div>

				</div>
			</div>

			<div className="dash-cards footer no-print">
				<nav className="navbar bottom-navbar navbar-light">
					<div className="navbar-footer me-0">
						<ul className="navbar-nav float-left"></ul>
						<ul className="navbar-nav float-right">
							<li className="nav-item">
								<Link className="nav-link btn-cancel d-none" to={{ pathname: endpoints.list }}>
									<i className="bi bi-chevron-left me-2"></i>
									<span>{language[lang]?.back ?? 'Voltar'}</span>
								</Link>

								<Link className="nav-link btn-cancel" to={{ pathname: (props.location.state !== null && props.location.state.go_back_operation === 'intranet_competicoes_regist' ? Intranet_Competicoes.regist.endpoint : endpoints.list), state: { item: (props.location.state !== null && props.location.state.item_go_back !== undefined ? props.location.state.item_go_back : null), operation: 'edit', tab: 'games' } } }  >
									<i className="bi bi-chevron-left me-2"></i>
									<span>{language[lang].back}</span>
								</Link>
							</li>
							<li className="nav-item">
								<button type="button" className="nav-link btn-delete" onClick={() => window.print()}>
									<i className="bi bi-printer me-2"></i>
									<span>{language[lang]?.print ?? 'Imprimir'}</span>
								</button>
							</li>
							{pode_editar && (
								<li className="nav-item d-none">
									<Link className="nav-link" to={{ state: { item: { id: jogo_id }, operation: 'edit' }, pathname: endpoints.regist }} replace>
										<i className="bi bi-pencil me-2"></i>
										<span>{language[lang]?.edit ?? 'Editar'}</span>
									</Link>
								</li>
							)}
							{pode_editar && (
								<li className="nav-item">
									<button type="button" className="nav-link" onClick={handleSubmit}>
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang]?.save ?? 'Guardar'}</span>
									</button>
								</li>
							)}
						</ul>
					</div>
				</nav>
			</div>
		</main>
	);
}